import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
// import { Drivers, Storage } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { UiService } from './services/ui.service';
import { AuthInterceptor } from './auth.interceptor';
import { AuthenticateService } from './services/authenticate.service';
import { SocketWebService } from './services/socket-web.service';
import { SocketIoModule ,SocketIoConfig} from 'ngx-socket-io';

const config: SocketIoConfig = { url: environment.urlSocket, options: {
      transports: ['websocket'],
  upgrade: false,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 5000,
   query: {
      // Se conecta a una sala "pública" o "por defecto" al inicio
      nameRoom: 'default-room' 
    }
} };
@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule, IonicModule.forRoot(), AppRoutingModule,
        IonicStorageModule.forRoot({
            name: '__mydb',
            // driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
        }),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
         SocketIoModule.forRoot(config),
    ],  
        
        providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        UiService, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
